export const GET_DATA_REQUEST = 'GET_DATA_REQUEST';
export const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
export const GET_DATA_FAILURE = 'GET_DATA_FAILURE';

// export const GET_REDDIT_USER_REQUEST = 'GET_REDDIT_USER_REQUEST';
// export const GET_REDDIT_USER_SUCCESS = 'GET_REDDIT_USER_SUCCESS';
// export const GET_REDDIT_USER_FAILURE = 'GET_REDDIT_USER_FAILURE';
